import { Link, useNavigate, useParams } from "react-router";
import Avvvatars from "avvvatars-react";
import { my_routes } from "../router/all_routes";
import { useEffect, useRef, useState } from "react";
import { getStudentById } from "../../api/etudiants";
import { toast } from "sonner";
import StudentBreadcrumb from "./studentBreadcrumb";
import StudentSidebar from "./studentSidebar";
import {
  createStudentParent,
  deleteStudentParent,
  getAllTypeLink,
  updateStudentParent,
} from "../../api/studentParent";
import EditLinkRow from "./EditLinkRow";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Modal } from "react-bootstrap";
import { Select } from "antd";

import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { getAllParents } from "../../api/parents";
import { getStudentArchivesById } from "../../api/archives";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import StudentArchive from "./studentArchives";
import StudentSanctionDetails from "./sanctions/studentSanctionDetails";
import InfosAlertYearDisabled from "../../core/common/alerts/infosAlertYearDisabled";
import withPermission from "../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import StudentEdtPage from "./studentEdtPage";
import { getAvatarFileById } from "../../api/avatar";
import StudentParentAssignmentModal from "./StudentParentAssignmentModal";

enum Sexe {
  Masculin = "Masculin",
  Feminin = "Feminin",
}

// Schema de notre formulaire de création de compte parent
const schema = z.object({
  lastname: z.string().nonempty("Veuillez insérer un nom"),
  firstname: z.string().nonempty("Veuillez insérer un prénom"),
  sexe: z.nativeEnum(Sexe, {
    errorMap: () => ({ message: "Veuillez sélectionner un type valide." }),
  }),
  isDeceased: z.boolean(),
  email: z
    .string()
    // .email("Veuillez fournir une adresse email valide")
    .optional(),
  number: z
    .string()
    // .regex(
    //   /^(\+223)?[456789]\d{7}$/,
    //   "Numéro de téléphone invalide. Ex: +22370123456 ou 70123456"
    // )
    .optional(),
  adresse: z.string().optional(),
  statut: z.enum(["true", "false"], {
    required_error: "Veuillez sélectionner un statut",
  }),
  relation: z.any(),
});

type FormFields = z.infer<typeof schema>;

//  shéma pour la vérification des parents
const parentShema = z.object({
  id: z.string(),
  value: z.string(),
  label: z.string(),
  relation: z
    .object({
      id: z.string(),
      label: z.string(),
    })
    .nullable()
    .refine((val) => val !== null && val !== undefined, {
      message: "La relation est obligatoire",
    }),
});

const parentsArrayShema = z.array(parentShema);

//  bouton protégée pour ajouter des liens
const ProtectedBtnAddLink = withPermission(
  (props: any) => (
    <button
      type="button"
      className="btn btn-primary"
      onClick={() => {
        props.setShow(true);
        props.setAssignedParent([]);
      }}
    >
      Ajouter un responsable
    </button>
  ),
  [buildPermission(Resource.STUDENT, Action.UPDATE)],
  "masquer",
);

//  bouton protégée pour modifier un lien
const ProtectedBtnUpdateLink = withPermission(
  (props: any) => (
    <button
      className="dropdown-item"
      onClick={() => props.setEditParentId(props.parentItem.id)}
    >
      Modifier Lien
    </button>
  ),
  [buildPermission(Resource.STUDENT, Action.UPDATE)],
  "masquer",
);

//  bouton protégée pour supprimer un lien
const ProtectedBtnDeleteLink = withPermission(
  (props: any) => (
    <button
      className="dropdown-item"
      onClick={() => {
        props.showDeleteConfirmationAlert(
          props.parentItem,
          props.parentItem.studentParentId,
        );
      }}
    >
      Supprimer Lien
    </button>
  ),
  [buildPermission(Resource.STUDENT, Action.UPDATE)],
  "masquer",
);

const StudentDetailsPage = () => {
  const { id } = useParams(); // On récupère l'id de l'URL

  const { selectedYear } = useAcademicYear();
  // Modal détails
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const parentSelectorRef = useRef(null);

  const [allLinks, setAllLinks] = useState<any>(); // les types de liens
  const [studentData, setStudentData] = useState<any>();
  const [editParentId, setEditParentId] = useState<any>();
  const [allParents, setAllParents] = useState<any[]>([]); // liste de tous les parents
  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données
  const [avatar, setAvatar] = useState<any>(null);
  // pour le select
  const [assignedParent, setAssignedParent] = useState<any[]>([]);

  // pour ne charger que les data des tab qui sont visibles
  const [selectedTab, setSelectedTab]= useState<string>("");
  //Initialisation de sweetAlert
  const MySwal = withReactContent(Swal);

  //  sweet alert pour la suppresion de lien
  const showDeleteConfirmationAlert = (parent: any, relation_id: string) => {
    MySwal.fire({
      title: "Supprimer lien ?",
      text: `Voulez-vous vraiment supprimer le lien de ${parent.firstname} ${parent.lastname} ?`,
      showCancelButton: true,
      confirmButtonText: "Supprimer",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête de suppression
          await deleteStudentParent(
            relation_id,
            buildPermissionContext(Resource.STUDENT, Action.UPDATE),
          );
          MySwal.fire({
            title: "Lien supprimé avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
          const parentDataUpdate = studentData.parents.filter(
            (parentItem: any) => parentItem.id !== parent.id,
          );
          setStudentData((prev: any) => ({
            ...prev,
            parents: parentDataUpdate,
          }));
        } catch (error) {
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text: "Échec de la suppression du lien. Veuillez réessayer.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  //   Initialisation de zod avec react-hook-form pour le compte parent
  const {
    reset: parentReset,
    clearErrors: parentClearErrors,
    formState: { errors: parentErrors, isSubmitting: parentIsSubmitting },
  } = useForm<FormFields>({
    resolver: zodResolver(schema),
  });

  // on récupère la liste des liens existant dans la base de donnée
  const getAllLink = async () => {
    try {
      const response = await getAllTypeLink(
        buildPermissionContext(Resource.STUDENT, Action.UPDATE),
      );
      setAllLinks(response.data);
    } catch (error) {
      // console.error(
      //   "Erreur lors de la récupération des types de liens:",
      //   error
      // );
      toast.error("Erreur lors de la récupération des types de liens");
    }
  };

  // Fonction pour changer le lien
  const handleSaveLinkChange = async (parentId: string, newLinkId: string) => {
    try {
      // Tu peux ajouter un appel API ici si besoin
      await updateStudentParent(
        parentId,
        { id_link: newLinkId },
        buildPermissionContext(Resource.STUDENT, Action.UPDATE),
      );
      const updatedLinkType = allLinks.find(
        (l: any) => l.id === newLinkId,
      )?.type;
      const parentDataUpdate = studentData.parents.map((parentItem: any) =>
        parentItem.studentParentId === parentId
          ? {
              ...parentItem,
              link: {
                ...parentItem.link,
                id: newLinkId,
                type: updatedLinkType,
              },
            }
          : parentItem,
      );
      setStudentData((prev: any) => ({ ...prev, parents: parentDataUpdate }));

      toast.success("Lien mis à jour !");
      setEditParentId(null);
    } catch (error) {
      // console.error("Erreur lors de la mise à jour :", error);
      toast.error("Échec de la mise à jour du lien.");
    }
  };

  // Fonction pour gérer la sélection des parents
  const handleParentChange = (
    selectedIds: string[],
    option?:
      | {
          id: string;
          value: string;
          label: string;
          relation: { id: string; label: string } | null;
        }
      | {
          id: string;
          value: string;
          label: string;
          relation: { id: string; label: string } | null;
        }[]
      | undefined,
  ) => {
    // option peut être undefined ou un tableau ou un objet, donc on doit gérer les cas
    let selectedOptions: {
      id: string;
      value: string;
      label: string;
      relation: { id: string; label: string } | null;
    }[] = [];
    if (option) {
      selectedOptions = [
        option as {
          id: string;
          value: string;
          label: string;
          relation: { id: string; label: string } | null;
        },
      ];
    } else {
      // fallback: reconstruire à partir des valeurs sélectionnées
      selectedOptions = allParents.filter((parent) =>
        selectedIds.includes(parent.id),
      );
    }
    // Ajoute la propriété relation: null par défaut si elle n'existe pas
    const newSelectedParent = selectedOptions.map((child) => ({
      ...child,
      relation: child.relation ?? null,
    }));
    setAssignedParent(newSelectedParent);
  };

  // Pour changer la relation avec un parent
  const updateRelation = (parentId: string, relationLabel: string) => {
    const matchedLink = allLinks.find(
      (link: any) => link.type === relationLabel,
    );

    if (!matchedLink) {
      console.warn(`Aucune relation trouvée pour ce label : ${relationLabel}`);
      toast.error(`Aucune relation trouvée pour ce label : ${relationLabel}`);
      return;
    }

    setAssignedParent((prev) =>
      prev.map((parent) =>
        parent.id === parentId ? { ...parent, relation: matchedLink } : parent,
      ),
    );
  };

  // Fonction pour les liens avec un parent déja existant
  const handleCreateLink = async () => {
    try {
      if (assignedParent.length <= 0)
        throw new Error("Veuillez sélectioner un parent");
      const formatData = assignedParent.map((dataItem) => ({
        id: dataItem.id,
        value: dataItem.id,
        label: `${dataItem.firstname} ${dataItem.lastname}`,
        relation: dataItem?.relation
          ? { id: dataItem.relation.id, label: dataItem.relation.type }
          : null,
      }));

      // console.log('Assgned Parent: ', assignedParent);
      // vérifie les parents sélectionnés
      const validation = parentsArrayShema.safeParse(formatData);

      if (!validation.success) {
        const errorMessage =
          validation.error.errors[0]?.message ||
          "Le format du parent est invalide ou une relation manquante.";
        // parentSetError("root", { message: errorMessage });
        toast.error(
          "Le format du parent est invalide ou une relation manquante.",
        );
        return;
      }
      // console.log("existent parent: ", studentData.parents);
      // obligé un compte parent de type mere ou père
      if (studentData.parents.length >= 1) {
        const exist = studentData?.parents.find(
          (parent: any) =>
            parent.link.type !== "Père" && parent.link.type !== "Mère",
        );

        if (
          exist &&
          assignedParent[0].relation.type !== "Père" &&
          assignedParent[0].relation.type !== "Mère"
        ) {
          toast.info(
            "Un seul parent peut être différent du Pere et de la Mere",
          );
          return;
        }
      }

      // limité le nombre de parent au nombre de role
      if (studentData.parents.length >= 3) {
        toast.info("Vous avez déja attibuer tous les rôles disponible");
        return;
      }

      const response = await createStudentParent({
        id_student: studentData.id,
        id_parent: assignedParent[0].id,
        id_link: assignedParent[0].relation?.id,
      });

      if (response) {
        setStudentData((prev: any) => {
          return {
            ...prev,
            parents: [
              ...prev.parents,
              {
                id: assignedParent[0].id,
                email: assignedParent[0].email,
                firstname: assignedParent[0].firstname,
                lastname: assignedParent[0].lastname,
                isDeceased: assignedParent[0].isDeceased,
                link: {
                  id: assignedParent[0].relation.id,
                  type: assignedParent[0].relation.type,
                },
                studentParentId: response.data.id,
              },
            ],
          };
        });
      }

      const btn = document.getElementById("cancel-btn");
      if (btn) btn.click();
    } catch (error: any) {
      toast.error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // Charger la photo de profil (avatar)
  const loadAvatar = async () => {
    try {
      // Récupérer URL temporaire API
      const resp = await getAvatarFileById("StudentProfil", id);
      const tempUrl = resp.data?.temporaryUrl;
      setAvatar(tempUrl);
    } catch (error: any) {
      // console.log("Erreur lors de la recuperation de l'avatar: ",error)
      toast.error(
        error.message ||
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  useEffect(() => {
    loadAvatar();
  }, [id]);

  // on récupère les infos de l'étudiant
  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        if (!id) throw new Error("L'id n'as pas pu être récupéré dans l'URL");
        const student = await getStudentById(id);
        // console.log("student info: ", student.data);
        const studentArchive = await getStudentArchivesById(id);
        if (selectedYear) {
          const studentArchData = studentArchive.data.find(
            (archiveItem: any) =>
              archiveItem?.id_academicYear === selectedYear.id,
          );

          const formattedData = selectedYear
            ? {
                ...student.data,
                class: studentArchData?.Class,
                academicYear: studentArchData?.AcademicYear,
              }
            : { ...student.data };
          setStudentData(formattedData);

          // console.log("student data formatted : ", formattedData);
        } else {
          const formattedData = { ...student.data };
          setStudentData(formattedData);
        }

        setIsLoading(false); //Les données ne sont plus en chargement
        setHasLoaded(true); //Les données ont été chargé avec succès
      } catch (error: any) {
        // console.log(error);
        // Si erreur (Toast Error)
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard",
        );
      }
    };
    const fetchParents = async () => {
      try {
        const response = await getAllParents(
          buildPermissionContext(Resource.STUDENT, Action.READ),
        );
        // console.log("all parents: ", response.data);
        const formattedParents = response.data.map((parent: any) => ({
          ...parent,
          id: parent.id,
          value: parent.id,
          label: `${parent.firstname} ${parent.lastname} ${"    "} ${
            parent?.number ? parent?.number : ""
          } ${parent?.email || ""}`,
        }));
        setAllParents(formattedParents);
      } catch (error: any) {
        // console.log("Erreur: récupération des parents ", error);
        toast.error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Une erreur s'est produit, Réessayer plus tard",
      );
      }
    };
    fetchStudentData();
    getAllLink();
  }, [selectedYear, id]);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {isLoading && !hasLoaded ? (
            <div className="card-body h-full">
              <div className="text-center">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="row">
                {/* Page Header */}
                <StudentBreadcrumb />
                {/* /Page Header */}
              </div>
              {!selectedYear?.statut && <InfosAlertYearDisabled />}
              <div className="row">
                {/* information de l'étudiant */}
                <StudentSidebar userData={{ ...studentData, avatar }} />
                {/* /information de l'étudiant */}
                <div className="col-xxl-9 col-xl-8">
                  <div className="row">
                    <div className="col-md-12">
                      {/* Liste */}
                      <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                        <li className="nav-item">
                          <Link
                            className="nav-link active"
                            to="#top-tab1"
                            data-bs-toggle="tab"
                            onClick={()=>{
                              setSelectedTab("top-tab1");}
                            }
                          >
                            <i className="ti ti-school me-2" />
                            Details Etudiant
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="#top-tab2"
                            className="nav-link"
                            data-bs-toggle="tab"
                           onClick={()=>{
                              setSelectedTab("top-tab2");}
                            } 
                          >
                            <i className="ti ti-table-options me-2" />
                            Emploi du Temps
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            className="nav-link"
                            to="#top-tab5"
                            data-bs-toggle="tab"
                            onClick={()=>{
                              setSelectedTab("top-tab5");}
                            }
                          >
                            <i className="ti ti-gavel me-2" />
                            Sanctions
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            className="nav-link"
                            to="#top-tab4"
                            data-bs-toggle="tab"
                            onClick={()=>{
                              setSelectedTab("top-tab4");}
                            }
                          >
                            <i className="ti ti-archive me-2" />
                            Archives
                          </Link>
                        </li>
                      </ul>
                      {/* /Liste */}
                      <div className="tab-content">
                        <div className="tab-pane show active" id="top-tab1">
                          {/* Informations Parent */}
                          <div className="card">
                            <div className="card-header ">
                              <div className="d-flex justify-content-between">
                                <h5>Informations Parents </h5>
                                {/* ajouter des liens */}
                                <ProtectedBtnAddLink
                                  setShow={setShow}
                                  setAssignedParent={setAssignedParent}
                                />
                              </div>
                            </div>
                            <div className="card-body">
                              {studentData?.parents &&
                                studentData.parents.map((parentItem: any) => (
                                  <div className="border rounded p-3 pb-0 mb-3">
                                    <div className="row">
                                      <div className="col-sm-6 col-lg-4">
                                        <div className="d-flex align-items-center mb-3">
                                          <span className="avatar avatar-lg flex-shrink-0">
                                            <Avvvatars
                                              value={`${
                                                parentItem.firstname?.charAt(
                                                  0,
                                                ) || ""
                                              }${
                                                parentItem.lastname?.charAt(
                                                  0,
                                                ) || ""
                                              }`}
                                              style="character" // ou "character"
                                            />
                                          </span>
                                          <div className="ms-2 overflow-hidden">
                                            <h6 className="text-truncate">{`${parentItem?.firstname} ${parentItem?.lastname}`}</h6>
                                            <p className="text-primary">
                                              {parentItem?.link.type.toUpperCase()}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-sm-6 col-lg-4">
                                        <div className="mb-3">
                                          <p className="text-dark fw-medium mb-1">
                                            Téléphone
                                          </p>
                                          <p>{parentItem?.number ?? "Aucun"}</p>
                                        </div>
                                      </div>
                                      <div className="col-sm-6 col-lg-4">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <div className="mb-3 overflow-hidden me-3">
                                            <p className="text-dark fw-medium mb-1">
                                              Email
                                            </p>
                                            <p className="text-truncate">
                                              {parentItem?.email ?? "Aucun"}
                                            </p>
                                          </div>
                                          <div className="dropdown">
                                            <Link
                                              to="#"
                                              data-bs-toggle="dropdown"
                                              aria-expanded="false"
                                              className="btn btn-dark btn-icon btn-sm mb-3"
                                            >
                                              <i className="ti ti-dots-vertical fs-14" />
                                            </Link>
                                            <div className="dropdown-menu dropdown-menu-end">
                                              {/* modifier un lien */}
                                              <ProtectedBtnUpdateLink
                                                setEditParentId={
                                                  setEditParentId
                                                }
                                                parentItem={parentItem}
                                              />
                                              {/* Supprimer un lien */}
                                              <ProtectedBtnDeleteLink
                                                showDeleteConfirmationAlert={
                                                  showDeleteConfirmationAlert
                                                }
                                                parentItem={parentItem}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        {editParentId === parentItem.id && (
                                          <EditLinkRow
                                            parent={parentItem}
                                            allLinks={allLinks}
                                            onSave={handleSaveLinkChange}
                                            onCancel={() =>
                                              setEditParentId(null)
                                            }
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>
                          {/* /Informations Parent */}
                          {/* Address */}
                          <div className="col-xxl-6 d-flex">
                            <div className="card flex-fill">
                              <div className="card-header">
                                <h5>Adresse</h5>
                              </div>
                              <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                  <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                                    <i className="ti ti-map-pin-up" />
                                  </span>
                                  <div>
                                    <p className="text-dark fw-medium mb-1">
                                      Adresse Actuelle
                                    </p>
                                    <p>{studentData?.adresse}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* /Address */}
                        </div>
                        <div className="tab-pane" id="top-tab2">
                          <StudentEdtPage id_class={studentData?.class?.id} isOpen={selectedTab==="top-tab2"}/>
                        </div>
                        <div className="tab-pane" id="top-tab3"></div>
                        <div className="tab-pane" id="top-tab4">
                          <StudentArchive />
                        </div>
                        <div className="tab-pane" id="top-tab5">
                          <StudentSanctionDetails
                            studentId={id!}
                            studentData={studentData}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <StudentParentAssignmentModal
        show={show}
        studentId={studentData?.id || id || ""}
        existingParentIds={(studentData?.parents || []).map((parent: any) => parent.id)}
        linkTypes={allLinks || []}
        onClose={handleClose}
        onAssigned={(parent) =>
          setStudentData((previous: any) => ({
            ...previous,
            parents: [...(previous?.parents || []), parent],
          }))
        }
      />
      <Modal
        show={false}
        onHide={handleClose}
        centered
        size="lg"
        id="add-parent-for-student"
      >
        <div className="modal-header">
          <h4 className="modal-title">Assigner Parent</h4>
          <button
            type="button"
            className="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body pb-0">
          {/* Selection des parents */}
          <div
            ref={parentSelectorRef}
            className="mb-12 flex-fill "
            id="parent-selector"
          >
            <label htmlFor="" className="form-label">
              Selectionné un Parent existant
            </label>
            <br />
            <Select
              id="parent-selector"
              className="select"
              getPopupContainer={() =>
                parentSelectorRef.current || document.body
              }
              style={{
                maxWidth: "500px",
                width: "100%",
                color: "white",
              }}
              placeholder="Please select"
              defaultValue={[]}
              value={assignedParent.map((parent) => parent.id)}
              options={
                studentData?.parents
                  ? allParents.filter(
                      (p) =>
                        !studentData?.parents.some(
                          (assigned: any) => assigned.id === p.id,
                        ),
                    )
                  : allParents
              }
              onChange={handleParentChange}
              // Permet de chercher par nom/prenom a lieu de l'id
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
            {assignedParent.length > 0 && (
              <div className="mt-2">
                <h6>Parent sélectionné :</h6>
                <ul className="list-group">
                  {assignedParent.map((parent) => (
                    <li
                      key={parent.id}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <span>{parent.label}</span>
                      <select
                        name=""
                        id=""
                        className="form-select ms-2"
                        style={{ maxWidth: "200px" }}
                        value={parent.relation?.type}
                        onChange={(e) =>
                          updateRelation(parent.id, e.target.value)
                        }
                      >
                        <option value="">Choisir une relation</option>
                        {allLinks.map((link: any) => {
                          const isUsed = studentData.parents.some(
                            (assigned: any) =>
                              assigned.link.type === link.type &&
                              assigned.id !== parent.id, // sauf pour le parent actuel
                          );
                          return (
                            <option
                              key={link.id}
                              value={link.type}
                              disabled={isUsed}
                              // selected={defaultLinkType?.id===link.id?true:false}
                            >
                              {link.type}
                            </option>
                          );
                        })}
                      </select>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className="mt-4 mb-3 d-flex justify-content-end mr-8">
              <Link
                to="#"
                id="cancel-btn"
                className="btn btn-light me-2"
                data-bs-dismiss="modal"
                onClick={() => {
                  parentReset();
                  parentClearErrors();
                  setAssignedParent([]);
                  setShow(false);
                }}
              >
                Annuler
              </Link>
              <button
                onClick={handleCreateLink}
                className="btn btn-outline-primary"
              >
                Assigner Parent
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default StudentDetailsPage;